<script setup lang="ts">
import { startOfMinute } from 'date-fns'
import { computed, ref } from 'vue'
import DolphinDateInput from '@/components/atoms/DolphinDateInput.vue'
import DolphinRadioButton from '@/components/atoms/DolphinRadioButton.vue'

const now = ref(startOfMinute(new Date()))
const model = defineModel<Date | null>({
  required: true,
})

const dateOptions = [
  {
    type: 'immediate',
    label: 'すぐに配信',
    handler: () => {
      model.value = null
    },
  },
  {
    type: 'scheduled',
    label: '予約配信',
    handler: () => {
      model.value = now.value
    },
  },
]

const selectedDateOption = computed(() => {
  if (model.value === null) {
    return 'immediate'
  }

  return 'scheduled'
})
</script>
<template>
  <div>
    <div :class="$style.optionsWrapper">
      <label
        v-for="dateOption of dateOptions"
        :key="dateOption.type"
        :class="$style.option"
      >
        <DolphinRadioButton
          name="dateOption"
          :value="dateOption.type"
          :modelValue="selectedDateOption"
          @update:modelValue="dateOption.handler"
        />
        <span :class="$style.option__text">
          {{ dateOption.label }}
        </span>
      </label>
    </div>

    <DolphinDateInput
      v-if="model !== null"
      :class="$style.customDateSetting"
      :model-value="model"
      @update:model-value="
        // nullが返ってきたらリセットする
        $event => (model = $event ?? now)
      "
      :min-date="now"
      clearable
    />
  </div>
</template>

<style module lang="scss">
.optionsWrapper {
  display: flex;
  gap: 24px;
}

.option {
  display: inline-flex;
  align-items: center;

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}

.customDateSetting {
  margin-top: 16px;
}
</style>
